import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">

                    {/* 1st block */}
                    <div className="col-span-12 lg:col-span-4">
                        <div className="box-border border-b-4 border-blue-900 p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                            <h3 className="font-bold text-4xl mb-4">Ykbal H.J.</h3>
                            <div className='text-md font-medium text-gray-600'>
                                <h5>Aşgabat şäheri</h5>
                                <p>6-njy kiçi etrapça,</p>
                                <p>6-njy köçe,</p>
                                <p>Jaý №6.</p>
                            </div>
                        </div>
                    </div>

                    {/* 2nd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                        <h6 className="text-[#013289] text-xl font-bold mb-4">LINK</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <HashLink to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Biz hakda</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Hyzmatlarymyz</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Habarlaşmak</HashLink>
                        </li>                            
                        </ul>
                    </div>

                    {/* 3rd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                        <h6 className="text-[#013289] text-xl font-bold mb-4">BIZIŇ HYZMATLARYMYZ</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <p className="text-[#013289]">Jaý gurluşygy</p>
                        </li>
                        <li className="mb-2">
                            <p  className="text-[#013289] ">Abatlaýyş we täzeden bezeg işleri</p>
                        </li>
                        <li className="mb-2">
                            <p className="text-[#013289] ">Fasad we içki dizaýn</p>
                        </li>
                        <li className="mb-2">
                            <p className="text-[#013289] ">Taslama taýýarlamak we konsalting</p>
                        </li>
                        </ul>
                    </div>

                    {/* 4th block */}
                    <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-blue-900">
                        <div className="text-xl mb-6">
                            Biz bilen habarlaşyň
                        </div>
                        <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center flex-col gap-2 mb-4 md:mb-0">
                                    <li>
                                        <Link to="#" className="flex justify-center p-1 items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out">📞 Telefon: +993 66 66-66-66</Link>
                                    </li>
                                    <li >
                                        <Link to="#" className="flex justify-center p-1 items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">📧 E-poçta: info@ykbalhj.com</Link>
                                    </li>
                                  <li >
                                        <Link to="#" className="flex justify-center p-1 items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">📍 Salgysy: Aşgabat, Türkmenistan</Link>
                                    </li>
                                </ul>
                            </div>
                    </div>          

                    </div>

                </div>
                
            </footer>
        </>
    )
}
export default Footer;
